import styled from 'styled-components';
import brasoes from '~/assets/brasoes.png';

export const Spacer = styled.div`
  width: 100%;
  height: 270px;
`;

export const Container = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 45px 45px 60px;

  @media (max-width: 992px) {
    justify-content: center;
  }
  @media (min-width: 992px) and (max-width: 5000px) {
    &.sticky {
      top: 0;
      position: fixed;
      z-index: 9998;
      background-color: #fff;
      padding: 20px 45px;
      animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
      h1 {
        height: 100px;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 4px;
        background-color: #831d13;
      }
    }
  }
  @keyframes slide-in-top {
    0% {
      -webkit-transform: translateY(-1000px);
      transform: translateY(-1000px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
export const Logo = styled.h1`
  width: 465px;
  max-width: 280px;
  /*min-width: 260px;*/
  /*height: 175px;*/
  height: 150px;
  background: url(${brasoes}) center no-repeat;
  background-size: contain;
  cursor: pointer;
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    left: -9999px;
  }
  @media (max-width: 1400px) {
    max-width: 25%;
    min-width: auto;
  }
  @media (max-width: 992px) {
    max-width: 50%;
  }
  @media (max-width: 692px) {
    max-width: 80%;
  }
`;
export const Navigation = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 860px;
  /* background-color: rgba(0, 0, 0, 0.01); */
  ul {
    list-style: none;
    display: flex;
    width: 100%;
    justify-content: space-between;
    li {
      font-size: 24px;
      font-weight: 900;
      color: #831d13;
      cursor: pointer;
      position: relative;
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0%;
        height: 1px;
        background-color: currentColor;
        transition: width 0.2s;
      }
      &:hover {
        &:after {
          width: 90%;
        }
      }
    }
  }
  @media (max-width: 1400px) {
    max-width: 550px;
    max-width: 70%;
    ul {
      li {
        font-size: 18px;
      }
    }
  }
  @media (max-width: 992px) {
    position: fixed;
    width: 100%;
    height: 100%;
    max-width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 9998;
    display: none;
    ul {
      flex-direction: column;
      align-items: center;
      li {
        margin-bottom: 45px;
        &:last-child {
          margin-bottom: 0;
        }
        a {
          border-radius: 10px;
          background-color: rgba(0, 0, 0, 0.95);
          padding: 15px 25px;
          text-transform: uppercase;
          color: #fff;
          font-size: 25px;
        }
      }
    }
    &.isOpen {
      display: flex;
    }
  }
`;

export const MobileTrigger = styled.div`
  position: fixed;
  display: none;
  -webkit-box-align: center;
  align-items: center;
  position: fixed;
  top: 0px;
  right: 0px;
  width: 60px;
  height: 60px;
  cursor: pointer;
  z-index: 9999;
  margin-top: 5px;
  margin-right: 15px;
  background-color: #fff;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 3px 3px 10px 0 rgba(0, 0, 0, 0.2);
  span {
    position: relative;
    display: block;
    width: 40px;
    height: 2px;
    background-color: #831d13;
    &:before,
    &:after {
      position: absolute;
      content: '';
      display: block;
      width: 100%;
      height: 2px;
      background-color: #831d13;
      left: 0px;
      transform-origin: center center;
      transition: all 0.2s linear 0s;
    }
    &:before {
      top: 0px;
      margin-top: -10px;
    }
    &:after {
      bottom: 0px;
      margin-bottom: -10px;
    }
  }
  @media (max-width: 992px) {
    display: flex;
  }
  &.isOpen {
    span {
      background-color: transparent;
      &:before {
        transform: rotate(45deg);
        margin: 0;
      }
      &:after {
        margin: 0;
        transform: rotate(-45deg);
      }
    }
  }
`;
